<template>
  <div>
    <v-col cols="12">
      <v-row v-if="informText != ''">
        <v-col cols="12">
          <v-alert type="error" style="width: 100%">
            {{ informText }}
          </v-alert>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">Selected Item(s): {{ selectedItem.length }}</v-col>
        <v-col cols="9">
          {{ listOrderNumber.join(", ") }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">Status</v-col>
        <v-col cols="9">
          <v-select
            :items="listStatus"
            :item-text="(obj) => obj.value"
            :item-value="(obj) => obj.id"
            label="All Status"
            dense
            outlined
            v-model="status"
            @change="
              showShortDesc(status);
              changeStatus();
              validation();
            "
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">Short Description</v-col>
        <v-col cols="9" v-if="listShortDescData.length > 0">
          <!-- <select class="form-control" v-model="short_description">
                        <option value="">Chosse Option</option>
                        <option v-for="i in listShortDescData" :key="i">{{i}}</option>
                    </select> -->
          <v-select
            :items="listShortDescData"
            label="Short Description"
            dense
            outlined
            v-model="short_description"
            @change="validation"
            @keyup="validation"
          ></v-select>
        </v-col>
        <v-col cols="9" v-else>
          <v-text-field
            v-model="short_description"
            label="Short Description"
            outlined
            dense
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">Detail Description</v-col>
        <v-col cols="9">
          <!-- <v-text-field v-model="detail_description" label="Detail Description" outlined dense @change="validation" @keyup="validation"></v-text-field> -->
          <v-textarea
            auto-grow
            rows="1"
            outlined
            dense
            background-color="white"
            row-height="15"
            v-model="detail_description"
            @change="validation"
            @keyup="validation"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-btn
            color="success"
            @click="saveData"
            v-if="selectedItem.length > 0 && showBtn == true"
            >Change Status</v-btn
          >
          <v-btn color="success" v-else disabled>Change Status</v-btn>
          &nbsp;

          <v-btn class="white--text" color="warning" @click="cancelData">
            Cancel <v-icon right dark>mdi-window-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
//import axios from "axios"
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});
export default {
  name: "ChangeStatus",

  props: {
    selectedItem: Array,
    username: String,
    sendStatus: String,
    //listStatus: Array,
  },

  data: () => ({
    loading: false,
    AuthStr: "",
    informText: "",
    status: "",
    listStatus: ["Processing", "On Hold", "Need Resend", "Refunded"],
    listOrderID: [],
    listOrderNumber: [],
    short_description: "",
    detail_description: "",
    listShortDesc: [
      {
        status: "On Hold",
        shortDesc: [
          "Vendor Issue",
          "Inkgo Issue",
          "Customily Issue",
          "Customer Issue",
          "Tracking Not Updated",
          "Designer Issue",
        ],
      },
      {
        status: "Refunded",
        shortDesc: [
          "Vendor Issue",
          "Inkgo Issue",
          "Customily Issue",
          "Customer Issue",
          "Tracking Not Updated",
          "Designer Issue",
        ],
      },
      {
        status: "Need Resend",
        shortDesc: [
          "Vendor Issue",
          "Inkgo Issue",
          "Customily Issue",
          "Customer Issue",
          "Tracking Not Updated",
          "Designer Issue",
        ],
      },
    ],
    listShortDescData: [],
    showBtn: false,
  }),

  methods: {
    showShortDesc(status) {
      console.log("Click");
      this.listShortDescData = [];

      for (const i of this.listShortDesc) {
        if (status == i.status) {
          for (const j of i.shortDesc) {
            this.listShortDescData.push(j);
          }
          break;
        }
      }

      console.log(this.listShortDescData);
    },

    async saveData() {
      this.loading = true;
      this.informText = "";

      var item = {
        new_status: this.status,
        short_description: this.short_description,
        detail_description: this.detail_description,
        order_ids: this.listOrderID,
        updated_user_username: this.username,
      };

      console.log(JSON.stringify(item));

      var currentSession = await this.$root.$refs.App.currentSession(
        "order-edit"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        //this.AuthStr = 'Bearer '.concat(accessToken);
        await fetch(window.domain + "orders/change-status", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(item),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("order-edit response: ", data);
            if (data.error_message == "") {
              this.$root.$refs.order.showAlert("status", this.listOrderNumber);
            } else {
              this.informText = data.error_message;
              return;
            }
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      }
    },

    changeStatus() {
      if (this.status != "Processing" || this.status != "In Production") {
        this.short_description = "";
        this.detail_description = "";
        this.showBtn = false;
      }
      console.log("shortDesc: ", this.short_description);
      console.log("detailtDesc: ", this.detail_description);
    },

    validation() {
      if (this.status == "Processing" || this.status == "In Production") {
        this.showBtn = true;
      } else if (
        this.status != "Processing" &&
        this.short_description.split("").length != 0 &&
        this.detail_description.split("").length != 0
      ) {
        this.showBtn = true;
      } else if (
        this.status != "In Production" &&
        this.short_description.split("").length != 0 &&
        this.detail_description.split("").length != 0
      ) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
      console.log("validation: ", this.showBtn);
    },

    checkRoles(str) {
      var a = this.$root.$refs.App.hashCode(str);

      if (this.$cookies.get("roles") != null) {
        var role = this.$cookies.get("roles").split(",");
        var index = role.indexOf(a.toString());
        if (index != -1) return true;
        else return false;
      } else return false;
    },

    cancelData() {
      this.$root.$refs.order.turnOffDialog();
    },
  },

  async mounted() {
    console.log(this.filterData);
    console.log(this.selectedItem);
    if (this.sendStatus == "Need Resend") {
      this.listStatus.push("In Production");
    }
    // var currentSession;
    // try{
    // currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
    // console.log("order-change-stt-currentSession: ",currentSession)
    // }catch(error){
    // console.log("order-change-stt-error: ",error)
    // }

    // if(currentSession != undefined) {
    //     let accessToken = currentSession.accessToken.jwtToken;
    //     this.AuthStr = 'Bearer '.concat(accessToken);

    //     for(const i of this.selectedItem){
    //         this.listOrderID.push(i.order_id)
    //         this.listOrderNumber.push(i.order_number)
    //     }
    // }
    // else
    // {
    //     this.$router.push("/login");
    // }
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    this.validation();
    for (const i of this.selectedItem) {
      this.listOrderID.push(i.order_id);
      this.listOrderNumber.push(i.order_number);
    }

    if (this.checkRoles("CS")) {
      this.listStatus = ["On Hold", "Need Resend", "Refunded"];
    }
  },
};
</script>

<style scoped>
</style>